module.exports = require('../dist/observable');
